import CustomTable from '../../../../../components/table/CustomTable';
import RequestStatusCard from './RequestStatusCard';
import DividerWithText from '../../../../../components/DividerWithText';
import { REQUEST_STATUS } from '../Model/Models';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import ActiveTableApp from "../Functionality/ActiveTableApp";
import RequestMealSubHeader from "./RequestMealSubHeader";
import React from "react";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const ActiveTab = (props) => {
    const {
        t,
        subView,
        userTypeId,
        setShowRequestModal,
        setExtraMealType,
        handleShowActive,
        handleShowHistory,
        setBodyForExport,
        searchElement,
        setSearchElement,
        option,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        getData,
        activeStep,
        modified,
        setModified,
        setItemSelected,
        setShowSummaryModal,
        setDeleteMealRequestShow,
        handleDownload
    } = props;

    const {
        tableId,
        searchId,
        tbody,
        thead,
        status,
        getActionsButtons,
        handleCheckboxChange,
        pagination,
        results,
        setResults,
        canCreate,
        handleCreate
    } = ActiveTableApp({
        modified,
        setModified,
        setItemSelected,
        searchElement,
        setShowSummaryModal,
        setShowRequestModal,
        setExtraMealType,
        setDeleteMealRequestShow,
        handleDownload
    });

    const hasContent = tbody?.data && tbody.data.length > 0;

    return (<>
            {userTypeId === USER_TYPE_MODEL.EMPLOYEE &&
                <RequestMealSubHeader
                    subView={subView}
                    handleShowActive={handleShowActive}
                    handleShowHistory={handleShowHistory}
                    searchId={searchId}
                    setBodyForExport={setBodyForExport}
                    results={results}
                    setResults={setResults}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    option={option}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    getData={getData}
                    userTypeId={userTypeId}
                    activeStep={activeStep}
                />
            }
            <div className={'row'}>
            {hasContent && (
                <>
                    <DividerWithText title={t('overview')} spacing={'mt-4 mb-2'} />
                    <RequestStatusCard
                        status={status}
                        statusToShow={[
                            REQUEST_STATUS.APPROVED.id,
                            REQUEST_STATUS.PENDING_REVIEW.id,
                            REQUEST_STATUS.IN_PROGRESS.id
                        ]}
                    />
                </>
            )}
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                childrenNotInformation={tbody?.data?.length === 0 ? <>
                        <div className={"warning-text"}>
                            <p>{t("you_have_not_created_requests_yet")}</p>
                        </div>
                        {canCreate && (
                            <CustomButtonLink
                                splitName={false}
                                id={'btn_at_create'}
                                card={true}
                                onClick={handleCreate}
                                name={'create_request'}
                            />
                        )}
                    </>
                    : undefined
                }
            />

            {pagination()}
        </div>
        </>
    );
};

export default ActiveTab;
